module.exports = __webpack_public_path__ + "static/img/K_tiles.7bec8d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/K_tiles.svg
// module id = NHq5
// module chunks = 1